import React from 'react';
import Button from '../atoms/Button';

/**
 * Horizontal stepper organism.
 * Reflects URL-driven step (1-indexed).
 */
export default function Stepper({
  steps = [],
  currentStep = 1,
  onStepClick,
  className = '',
  size = 'md',
  showSaveButton = false,
  showNextButton = false,
  onSaveDraft,
  onNext,
  saveLabel = 'Save Draft',
  nextLabel = 'Next >',
}) {
  return (
    <div className={`ca-stepper-wrap ca-stepper-wrap--${size} ${className}`.trim()}>
      <nav className={`ca-stepper ca-stepper--${size}`} aria-label="Progress">
        {steps.map((step, index) => {
        const stepId = step.id ?? index + 1;
        const isActive = stepId === currentStep;
        const isDone = stepId < currentStep;
        const clickable = Boolean(onStepClick) && (isDone || isActive);

          return (
            <React.Fragment key={stepId}>
              {index > 0 ? <div className="ca-stepper__line" /> : null}
              <button
                type="button"
                className={[
                  'ca-stepper__item',
                  isActive ? 'ca-stepper__item--active' : '',
                  isDone ? 'ca-stepper__item--done' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
                onClick={() => clickable && onStepClick?.(stepId)}
                disabled={!clickable}
                aria-current={isActive ? 'step' : undefined}
              >
                <span className="ca-stepper__circle">{stepId}.</span>
                <span className="ca-stepper__label">{step.label}</span>
              </button>
            </React.Fragment>
          );
        })}
      </nav>
      {showSaveButton || showNextButton ? (
        <div className="ca-stepper__actions">
          {showSaveButton ? (
            <Button variant="outline" onClick={onSaveDraft}>{saveLabel}</Button>
          ) : null}
          {showNextButton ? <Button onClick={onNext}>{nextLabel}</Button> : null}
        </div>
      ) : null}
    </div>
  );
}
